import {NodeInputProps} from "./index";
import React, {FunctionComponentElement, useState} from "react";
import {Button} from "primereact/button";
import {useTranslation} from "react-i18next";
import {PasswordEditModal} from "./password_edit_modal";

export const PasswordInput = (props: NodeInputProps): FunctionComponentElement<NodeInputProps> => {
    const {t} = useTranslation();
    const [visible, setVisible] = useState(false);

    return (
        <div className={"flex justify-content-center"}>
            <Button className={"m-3 w-6"} icon={"pi pi-pencil"} disabled={props.disabled} label={t("button.edit-password")}
                    onClick={() => setVisible(true)}/>

            <PasswordEditModal onHide={() => setVisible(false)}
                               onSubmit={props.onChange}
                               visible={visible}/>
        </div>
    );
}